// 26.1.10 Reflect.isExtensible(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});



//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/core-js/modules/es6.reflect.is-extensible.js
// module id = ../../../../core-js/modules/es6.reflect.is-extensible.js
// module chunks = 0